import script from "./menu.vue?vue&type=script&lang=ts&setup=true"
export * from "./menu.vue?vue&type=script&lang=ts&setup=true"

import "./menu.vue?vue&type=style&index=0&id=3dcf7d15&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dcf7d15"]])

export default __exports__